// extracted by mini-css-extract-plugin
export default {"button":"Button-module_button__N1QQf","basic":"Button-module_basic__WLuZo","fullWidth":"Button-module_fullWidth__eH8ji","disabled":"Button-module_disabled__cTv0n"};